"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClaimingDescTextKey = void 0;
function getClaimingDescTextKey(userMeta, velocityOffer, credentialUserEmail) {
    if ((velocityOffer === null || velocityOffer === void 0 ? void 0 : velocityOffer.isClaimingMandatory) === false) {
        return "claimInfo";
    }
    if ((velocityOffer === null || velocityOffer === void 0 ? void 0 : velocityOffer.isClaimingMandatory) === true ||
        userMeta.userId === (velocityOffer === null || velocityOffer === void 0 ? void 0 : velocityOffer.userId)) {
        return "claimCredentialDescText";
    }
    if (!userMeta.logged ||
        !userMeta.userEmails
            .map((e) => e.value.toLowerCase())
            .includes(credentialUserEmail.toLowerCase())) {
        return "onlyOwnerCanClaim";
    }
    return "switchAccountDescText";
}
exports.getClaimingDescTextKey = getClaimingDescTextKey;
